export interface ISortable {
	order?: number | null;
}

export function isSortable(object: any): object is ISortable {
	return "order" in object;
}

export function isSortableArray(object: any[]): object is ISortable[] {
	return object && !!object.length && "order" in object[0];
}
